exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wishPage{margin-top:80px;margin-bottom:50px}.wishPage:before,.wishPage:after{content:\"\";display:table}.wishPage:after{clear:both}.wishPage .child-info{margin:40px auto;text-align:center}.wishPage .form-info{margin-bottom:30px}@media screen and (max-width: 767px){.wishPage{margin-top:20px;margin-bottom:0px}.wishPage h1{font-size:32px;text-align:left}.wishPage .child-info{display:flex;flex-direction:row;align-items:center;justify-content:left;text-align:left;width:100%}.wishPage .child-info img.child-img{margin:0 20px 0 0}.wishPage .child-info .child-name-bar h4{font-size:16px;margin-bottom:3px}.wishPage .child-info .child-name-bar .child-age{font-size:14px;font-weight:400;color:#999}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Containers/Wish.scss
// module id = 963
// module chunks = 0